import { render, staticRenderFns } from "./recommendPageNew.vue?vue&type=template&id=abbebe36&scoped=true&"
import script from "./recommendPageNew.vue?vue&type=script&lang=js&"
export * from "./recommendPageNew.vue?vue&type=script&lang=js&"
import style0 from "./recommendPageNew.vue?vue&type=style&index=0&id=abbebe36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbebe36",
  null
  
)

export default component.exports